// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AdminContact } from './admin-contact';
import { Counterparty } from './counterparty';
import { CounterpartyCounterpartyType } from './counterparty-counterparty-type';
import { MergeTemplate } from './merge-template';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CounterpartyType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  counterpartyTypeId!: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  locationId!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  adminContacts!: AdminContact[];
  counterparties!: Counterparty[];
  counterpartyCounterpartyTypes!: CounterpartyCounterpartyType[];
  mergeTemplates!: MergeTemplate[];
}

